import { defineMessages } from 'react-intl'

import { EConfirmationModality } from 'features/Bookings/types'

export const confirmationModalitiesMessages = defineMessages({
  [EConfirmationModality.PAID]: {
    id: 'confirmationModalities.paid',
    defaultMessage: 'Paid'
  },
  [EConfirmationModality.RESERVED]: {
    id: 'confirmationModalities.reserved',
    defaultMessage: 'Reserved'
  },
  [EConfirmationModality.FACEBOOK]: {
    id: 'confirmationModalities.facebook',
    defaultMessage: 'Facebook'
  }
})
